import { State } from "../state";

export interface StarLabelAction {
  taxonomyName: string;
  label: any;
  type: "STAR LABEL";
}

export const starLabel = (
  state: State,
  action: StarLabelAction,
): State => {
  let currentStarredIndex = state.taxonomy.orderedLabels.starred?.findIndex(x => x === action.label);
  let newStarred = state.taxonomy.orderedLabels.starred;
  let newOrderedLabels = {...state.taxonomy.orderedLabels};

  delete newOrderedLabels.starred;
  if (currentStarredIndex === -1 || currentStarredIndex === undefined) {
    if (!newStarred) {
      newStarred = [action.label]
    } else {
      newStarred = [...newStarred, action.label]
    }
  } else {
    newStarred.splice(currentStarredIndex, 1);
  }
  if (newStarred?.length > 0) {
    newOrderedLabels = {starred:newStarred, ...newOrderedLabels}
  }

  localStorage.setItem("user_starred_" + action.taxonomyName, JSON.stringify(newStarred))

  return {
    ...state,
    taxonomy: {
      ...state.taxonomy,
      orderedLabels: newOrderedLabels
    }
  };
};